import { Options, toCamel, toSnake } from 'change-object-case';

export const fromApiFormat = <S extends object | object[]>(data: S, options: Options = {}): S => {
  return toCamel(data, { recursive: true, arrayRecursive: true, ...options });
};

export const toApiFormat = (data: object, options: Options = {}): object => {
  return toSnake(data, { recursive: true, arrayRecursive: true, ...options });
};
